import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgExclamationTriangle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.00789 0.649345C8.55285 -0.114154 7.44715 -0.114154 6.9921 0.649346L0.171924 12.0926C-0.294212 12.8747 0.269337 13.8667 1.17982 13.8667H14.8202C15.7307 13.8667 16.2942 12.8747 15.8281 12.0926L9.00789 0.649345ZM7.90837 1.19544C7.94974 1.12603 8.05026 1.12603 8.09163 1.19544L14.9118 12.6387C14.9542 12.7098 14.9029 12.8 14.8202 12.8H1.17982C1.09706 12.8 1.04582 12.7098 1.08819 12.6387L7.90837 1.19544ZM7.28203 4.78518C7.26636 4.37784 7.59235 4.03907 8 4.03907C8.40765 4.03907 8.73363 4.37784 8.71797 4.78519L8.55382 9.05281C8.54238 9.3504 8.29781 9.58575 8 9.58575C7.70219 9.58575 7.45761 9.3504 7.44617 9.05281L7.28203 4.78518ZM8.79988 11.1744C8.79988 11.6162 8.44171 11.9744 7.99988 11.9744C7.55805 11.9744 7.19988 11.6162 7.19988 11.1744C7.19988 10.7326 7.55805 10.3744 7.99988 10.3744C8.44171 10.3744 8.79988 10.7326 8.79988 11.1744Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgExclamationTriangle)
const IconSvgExclamationTriangle = createIcon(
  ForwardRef,
  'SvgExclamationTriangle',
)
export default IconSvgExclamationTriangle
